import {
  CREATE_ANONYMOUS_SESSION_REQUEST,
  CREATE_ANONYMOUS_SESSION_SUCCESS,
  CREATE_ANONYMOUS_SESSION_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  CHECK_EMAIL_REQUEST,
  CHECK_EMAIL_SUCCESS,
  CHECK_EMAIL_FAILURE,
  RESET_CHECKED_EMAIL,
  SET_AUTHENTICATION_MODAL_IS_VISIBLE,
  PATCH_PHONE_NUMBER_REQUEST,
  PATCH_PHONE_NUMBER_SUCCESS,
  PATCH_PHONE_NUMBER_FAILURE,
  RESET_FORGOT_PASSWORD,
  POST_FORGOT_EMAIL_SUCCESS,
  EMAIL_IS_UNCONFIRMED,
  RESET_AUTH_REDUCER,
  GET_APP_CONFIG,
} from './authTypes';
import {DELIVERY_ADDRESSES_FORM_IS_VISIBLE} from '../DeliveryAddresses/deliveryAddressesTypes';
import {DROPOFF_LOCATION_FORM_IS_VISIBLE} from '../DropOff/dropOffLocationTypes';
import api from '../../api';
import {navigate} from 'gatsby';
import appConfig from '../../../app-config';
import {createAlert} from '../Alert/alertActions';
import analytics from '../../utils/analytics';
import {hideToolTip} from '../OrderSetting/orderSettingActions';
import {updateOrderSettingModalIsVisible} from '../OrderSetting/orderSettingActions';

const source = appConfig.appSource;

const UNCONFIRMED = 'UNCONFIRMED';

export function createAnonymousSession() {
  return function(dispatch) {
    dispatch({type: CREATE_ANONYMOUS_SESSION_REQUEST});
    return api.post(`/sessions`, {source}).then(
      response => {
        localStorage.setItem(
          `${appConfig.appSource}_token`,
          response.data.data.session_id
        );
        dispatch({
          type: CREATE_ANONYMOUS_SESSION_SUCCESS,
          response: response.data,
        });
      },
      error => {
        dispatch({type: CREATE_ANONYMOUS_SESSION_FAILURE, error});
      }
    );
  };
}

export function login({password}) {
  return function(dispatch, getState) {
    dispatch({type: LOGIN_REQUEST});
    let body = {
      email: getState().authReducer.checkedEmail,
      password,

      source,
    };

    const coords = getState().locationsReducer.currentLocation;

    if (coords) {
      body = {
        ...body,
        latitude: coords.latitude,
        longitude: coords.longitude,
      };
    } else {
      body = {
        ...body,
        latitude: 0,
        longitude: 0,
      };
    }
    return api.post(`/login`, body).then(
      response => {
        const {status} = response.data.data;
        if (status === UNCONFIRMED) {
          dispatch({type: 'TO_CONFIRM_SMS'});
          dispatch({
            type: EMAIL_IS_UNCONFIRMED,
            token: response.data.data.token,
          });
          localStorage.setItem(
            `${appConfig.appSource}_token`,
            response.data.data.token
          );
        } else {
          // analytics.initialize(response.data.data.token);

          dispatch({
            type: LOGIN_SUCCESS,
            token: response.data.data.token,
          });
          // dispatch(updateOrderSettingModalIsVisible(true));

          localStorage.setItem(
            `${appConfig.appSource}_token`,
            response.data.data.token
          );
          // localStorage.removeItem('isRegistering');
        }
      },
      error => {
        // createServerErrorAlert(dispatch, error);
        dispatch({type: LOGIN_FAILURE});
      }
    );
  };
}

export function logout() {
  return function(dispatch) {
    dispatch({type: LOGOUT_REQUEST});
    navigate('/');
    dispatch(hideToolTip());
    return api.post(`/logout`).then(
      response => {
        dispatch({type: LOGOUT_SUCCESS});

        localStorage.removeItem(`${appConfig.appSource}_token`);
      },
      error => {
        // dispatch({type: LOGOUT_FAILURE});
        dispatch({type: LOGOUT_SUCCESS});

        // navigate('/');
        localStorage.removeItem(`${appConfig.appSource}_token`);
      }
    );
  };
}

export function postForgotPassword(email) {
  return function(dispatch) {
    return api.post(`/password/forgot`, {email, source}).then(response => {
      dispatch({type: POST_FORGOT_EMAIL_SUCCESS});
    });
  };
}

export function resetForgotPassword() {
  return {
    type: RESET_FORGOT_PASSWORD,
  };
}

export function checkEmail(values) {
  return function(dispatch) {
    dispatch({type: CHECK_EMAIL_REQUEST});
    return api
      .post(`/registration/email/availability`, {
        email: values.email,
        source: source,
      })
      .then(
        response => {
          dispatch({
            type: CHECK_EMAIL_SUCCESS,
            emailIsAvailable: response.data.data.is_available,
            checkedEmail: values.email,
          });
        },
        error => {
          dispatch({type: CHECK_EMAIL_FAILURE});
        }
      );
  };
}

export function resetCheckedEmail() {
  return {
    type: RESET_CHECKED_EMAIL,
  };
}

export function setAuthenticationModalIsVisible(bool) {
  return function(dispatch, getState) {
    const {isAuthenticated} = getState().authReducer;
    dispatch({type: SET_AUTHENTICATION_MODAL_IS_VISIBLE, bool});
    if (!isAuthenticated && !bool) {
      dispatch({type: DELIVERY_ADDRESSES_FORM_IS_VISIBLE, isVisible: false});
      dispatch({type: DROPOFF_LOCATION_FORM_IS_VISIBLE, isVisible: false});
    }
  };
}

export function updatePhoneNumber(phone_number) {
  return function(dispatch) {
    dispatch({type: PATCH_PHONE_NUMBER_REQUEST});
    api
      .patch(`/registration/phone`, {phone_number})
      .then(response => {
        dispatch({type: PATCH_PHONE_NUMBER_SUCCESS});
        dispatch(
          createAlert({
            type: 'success',
            message: 'Phone Number Updated Successfully',
          })
        );
      })
      .catch(error => {
        dispatch({type: PATCH_PHONE_NUMBER_FAILURE, error});
      });
  };
}

export function resetAuthReducer() {
  return {
    type: RESET_AUTH_REDUCER,
  };
}

export function getAppConfig() {
  return function(dispatch) {
    api.get(`/config?source=${source}&platform_id=${3}`).then(response => {
      dispatch({type: GET_APP_CONFIG, appConfig: response.data.data});
    });
  };
}

export function loadReactGA() {
  return function(dispatch, getState) {
    // ReactGA.pageview('/');
    // ReactGA.event({
    //   category: 'user visits web ordering',
    //   action: 'user visits web ordering',
    // });
  };
}
